import { isCampaignEnabled } from '../../jsCore/config/campaignConfig'
import { register } from '../../components/viewability/viewbilityTracker'
import { trackUserIdentifier } from '../../components/googleAnalyticaSessionTracker/useridentifierTracker'
import { getPageLocale } from '../../jsCore/application/pageDataObject'

const experimentId = parseInt(trackUserIdentifier())

const fixtureFirstTest = `https://cdn.deep.it/article/embed.js?containerId=deep&widgetTypes=TeamFixtures&widgetParams=WIDGET_VERSION%3DV1%26LANGUAGE_CODE%3D${getPageLocale()}`
const fixtureSecondTest = `https://cdn.deep.it/article/embed.js?containerId=deep&widgetTypes=TeamFixtures&widgetParams=WIDGET_VERSION%3DV2%26LANGUAGE_CODE%3D${getPageLocale()}`

function getABTestExperimentValue(
  minRangeExperimentA,
  maxRangeExperimentA,
  minRangeExperimentB,
  maxRangeExperimentB,
  experimentA,
  experimentB
) {
  if (minRangeExperimentA <= experimentId && maxRangeExperimentA >= experimentId) {
    return experimentA
  }
  if (minRangeExperimentB <= experimentId && maxRangeExperimentB >= experimentId) {
    return experimentB
  }
  return null
}

const DEEP_FIXTURE_WIDGET = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepFixtureWidgetPlaceHolder',
  id: 'deep',
  src: getABTestExperimentValue(1, 50, 51, 100, fixtureFirstTest, fixtureSecondTest),
  name: 'deep_fixture',
  site: '90min',
  locales: ['it'],
  position: 2,
}

var campaigns = [DEEP_FIXTURE_WIDGET]

function addPlaceHolder(campaign) {
  let placeHolder = document.querySelectorAll('.post-content > p')[campaign.position]
  if (placeHolder !== undefined && placeHolder !== null) {
    placeHolder.insertAdjacentHTML(
      'beforeend',
      `<div class=${campaign.placeHolder} id=${campaign.id} style="margin-top:24px;margin-bottom:24px" ></div>`
    )
  }
}

function injectScript(campaign) {
  let script = document.createElement('script')
  script.src = campaign.src
  script.async = true
  document.head.appendChild(script)
}

export function injectFixtureWidget() {
  campaigns.forEach(campaign => {
    isCampaignEnabled(campaign).then(response => {
      if (response.isCampaignEnabled) {
        addPlaceHolder(campaign)
        injectScript(campaign)
        register('.' + campaign.placeHolder)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fixture_widget/fixture_widget.js